export default __webpack_public_path__ + "static/media/gallery_01.aac6ec07.jpg";